import React, { useEffect, useState } from 'react'
import DefaultTabs from '../../components/DefaultTabs/Tabs'
import { PasswordChangeIcon, ProfileIcon } from "../../utils/svgIcons";
import EditProfile from "../../AuthPages/EditProfile";
import ChangePassword from "../../AuthPages/ChangePassword";
import { useLocation } from "react-router-dom";

function Settings() {
  const location = useLocation();
  const [defaultTab, setDefaultTab] = useState("PersonalDetails");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = queryParams.get("tab");
    if (tabFromQuery) {
      setDefaultTab(tabFromQuery);
    }else{
      setDefaultTab("PersonalDetails")
    }
  }, [location.search]);

  const tabs = [
    {
      key: "PersonalDetails",
      title: "Personal Details",
      icon: <ProfileIcon />,
      component: <EditProfile />,
    },
    {
      key: "ChangePassword",
      title: "Change Password",
      icon: <PasswordChangeIcon />,
      component: <ChangePassword />,
    },
  ];
  return (
    <div>
      <DefaultTabs defaultTab={defaultTab} tabs={tabs} />
    </div>
  )
}

export default Settings